import { EHumanReviewRequestSubject } from 'src/pages/dashboard/_components/human-review-requests.type'

export enum ETriggerUnit {
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months',
}

export enum ETriggerTiming {
  BEFORE = 'before',
  AFTER = 'after',
}

export enum EDurationUnit {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
}

export type TChatbotGeneralFormValues = {
  name: string
  description?: string
  isActive?: boolean
  schedule: {
    triggerDelay: number
    triggerUnit: ETriggerUnit
    triggerTiming: ETriggerTiming
    sendAt?: string | null
    allowedDays: number[]
    medeventListIds: number[]
    avoidHolidays: boolean
  }
  options: {
    automaticEnd?: {
      expireDuration?: number
      expireDurationUnit?: EDurationUnit
      expirationMessage?: string
    } | null
    requestHumanReview?: {
      subject?: EHumanReviewRequestSubject | null
      incompleteQuestionnaireDelay?: string | null
      unreceivedSmsDelay?: string | null
    } | null
    automaticRelaunchDelay?: string | null
  }
}

export const DEFAULT_ALLOWED_DAYS = [1, 2, 3, 4, 5]
